import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-else",
  "use": "icon-else-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-else\"><g id=\"icon-else_fill\"><path d=\"M12,.5A11.5,11.5,0,1,0,23.5,12,11.51,11.51,0,0,0,12,.5ZM12,21a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z\" /><polygon points=\"13.54 7.16 10.88 7.16 10.88 10.62 7.37 10.62 7.37 13.35 10.88 13.35 10.88 16.85 13.54 16.85 13.54 13.35 17.05 13.35 17.05 10.62 13.54 10.62 13.54 7.16\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol